import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-deployments.sidebar-content.configuration.title',
		defaultMessage: 'Deployments Settings',
		description:
			'Title of the view configuration sidebar to see deployment table information differently',
	},
	issuesSection: {
		id: 'software-deployments.sidebar-content.configuration.issues-section',
		defaultMessage: 'Issues',
		description: 'Title of the issues configuration section',
	},
	showIssuesWithoutDeployments: {
		id: 'software-deployments.sidebar-content.configuration.show-issues-without-deployments',
		defaultMessage: 'Show issues without deployments',
		description: 'Checkbox label for show issues without deployments',
	},
	confirmButtonLabel: {
		id: 'software-deployments.sidebar-content.configuration.confirm-button-label',
		defaultMessage: 'Save changes',
		description:
			'Button label. When this is pressed, it will permanently change personal view configuration.',
	},
	cancelButtonLabel: {
		id: 'software-deployments.sidebar-content.configuration.cancel-button-label',
		defaultMessage: 'Cancel',
		description: 'Cancel button label',
	},
	configLoadingErrorFlagTitle: {
		id: 'software-deployments.sidebar-content.configuration.config-loading-error-flag-title',
		defaultMessage: 'Unable to load view configuration.',
		description:
			'When fetching configuration view fails, we show this error title in the bottom-left corner together with description',
	},
	configLoadingErrorFlagDescription: {
		id: 'software-deployments.sidebar-content.configuration.config-loading-error-flag-description',
		defaultMessage: 'Please refresh the page to load your view configuration.',
		description:
			'When fetching configuration view fails, we show this error message in the bottom-left corner',
	},
	configMutationErrorFlagTitle: {
		id: 'software-deployments.sidebar-content.configuration.config-mutation-error-flag-title',
		defaultMessage: 'Unable to save your view settings.',
		description:
			'When user changed view configuration, we try to save it in the server. This is the title for error the message box which is displayed in the bottom-left corner when saving failed',
	},
	configMutationErrorFlagDescription: {
		id: 'software-deployments.sidebar-content.configuration.config-mutation-error-flag-description',
		defaultMessage: 'Please try again to configure your Deployments view.',
		description:
			'When user changed view configuration, we try to save it in the server. This is the description for the error message box which is displayed in the bottom-left corner when saving failed',
	},
	showIssuesWithoutDeploymentsRemoved: {
		id: 'software-deployments.sidebar-content.configuration.show-issues-without-deployments-removed',
		defaultMessage: 'You can no longer filter issues without deployments.',
		description:
			'Message shown when the "show issues without deployments" option is removed from the deployment timeline config options. The workaround is for customers to use the issue navigator which is the link.',
	},
});
